import React, { useState, useRef } from "react";
import { usePapaParse } from "react-papaparse";
import { useCSVDownloader } from "react-papaparse";
import s from "./CsvDownloader.module.scss";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";
import { Button, message } from "antd";
import dayjs from "dayjs";
import { PromoCodeResponse } from "../../../../../../libs/Utils/Types/PromoCode";

type PropType = {
  filename: string;
  token: string;
  filter: string;
  endpointKey: string;
  pageItems: number;
};

function CsvDownloader({
  filename,
  filter,
  endpointKey,
  token,
  pageItems,
}: PropType) {
  const [loading, setLoading] = useState<boolean>(false);
  const [csvData, setCsvData] = useState<any[]>([]);
  const { jsonToCSV } = usePapaParse();
  const { CSVDownloader, Type } = useCSVDownloader();

  // ref for the CSV downloader
  const csvRef = useRef<HTMLButtonElement>(null);

  const fetchAllMessages = async () => {
    let page = 1;
    const limit = pageItems;
    let allDocs: PromoCodeResponse["data"] = [];
    let totalPages = 1;

    setLoading(true);

    try {
      do {
        const res: PromoCodeResponse = await swrFetcher([
          endpointKey,
          token,
          { page, limit, ...(filter && { status: filter }) },
        ]);

        allDocs = allDocs.concat(res.data);
        totalPages = res.pagination.totalPages;
        page++;
      } while (page <= totalPages);

      const filteredDocs =
        allDocs &&
        allDocs.map((code) => ({
          description: code.description || "N/A",
          code: code.name || "N/A",
          usesageLimit: code.usageLimit || "N/A",
          amount:
            code.type === "percentage"
              ? code.creditPercentage?.toString() + "%" || "N/A"
              : code.maxCredit || "N/A",
          startDate:
            dayjs.utc(code.startDate).local().format("MMM D, YYYY") || "N/A",
          recipients: code.recipientCount || 0,
          endDate: dayjs.utc(code.endDate).local().format("MMM D, YYYY"),
          redemption: code.totalUsage,
          status: code.status || "N/A",
        }));
      setCsvData(filteredDocs);
      message.success("All data fetched — download starting…");

      // trigger the CSV download automatically
      setTimeout(() => {
        csvRef.current?.click();
      }, 500); // slight delay so state updates fully before download
    } catch (error) {
      console.error(`Error fetching ${filename}:`, error);
      message.error(`Failed to fetch ${filename}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={s.wrapper}>
      <Button onClick={fetchAllMessages} loading={loading} className={s.button}>
        {"Download CSV"}
      </Button>

      {/* Hidden CSV Downloader */}
      {csvData.length > 0 && (
        <CSVDownloader
          type={Type.Button}
          filename={new Date() + " Cloudivi " + filename}
          bom={true}
          config={{ delimiter: ";" }}
          data={() => jsonToCSV(csvData)}
        >
          <button ref={csvRef} style={{ display: "none" }}>
            Download
          </button>
        </CSVDownloader>
      )}
    </div>
  );
}

export default CsvDownloader;
